// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gj-a";
export var fulfillmentFormRail = "_gj-9";
export var headerTitleRow = "_gj-c";
export var orderDetailsWrapper = "_gj-7";
export var orderLinkTrigger = "_gj-2";
export var paymentInformationGrid = "_gj-h";
export var paymentSummaryColumn = "_gj-i";
export var shipmentContainer = "_gj-b";
export var shipmentDetailsMainPane = "_gj-8";
export var shipmentNavigationCard = "_gj-5";
export var shipmentNavigationRail = "_gj-3";
export var shipmentNavigationRailHeader = "_gj-4";
export var shipmentSummaryFact = "_gj-e";
export var shipmentSummaryGrid = "_gj-d";
export var shipmentSummaryMetadataRow = "_gj-f";
export var shipmentSummaryTags = "_gj-g";
export var shipmentWorkspace = "_gj-0";
export var shipmentWorkspaceContent = "_gj-6";
export var shipmentWorkspaceHeader = "_gj-1";